import type { QueryClient } from '@tanstack/react-query';

/**
 * Сброс кеша списка событий календаря и принудительный refetch всех совпадающих запросов,
 * в т.ч. не смонтированных сейчас (иначе при refetchOnMount: false глобально список не обновится до F5).
 */
export function refetchAllCalendarEventQueries(queryClient: QueryClient): Promise<void> {
  return queryClient.invalidateQueries({
    queryKey: ['calendarEvents'],
    exact: false,
    refetchType: 'all',
  });
}
